// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"r1-z"};